import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { CndzkEntranceApi } from "./apiModel";
import { formatJsonpDataForMtop } from "../utils/formatJsonp";
var Services = /*#__PURE__*/function () {
  function Services(props) {
    this.api = void 0;
    this.config = {
      apiModel: 'mtop',
      applicationType: 'query',
      apiType: 'cndzk',
      businessId: '',
      realm: 'default',
      urlBase: '',
      iso: 'CN',
      isJsonpForMtop: false,
      hideSensitiveDivision: true
    };
    this.config = _extends({}, this.config, props.config || {});
    this.api = {
      get: function get() {}
    };
    if (this.config.apiModel === 'api') {
      if (!this.config.urlBase) {
        console.error('CnAddress Error: urlBase is required');
        return;
      }
      this.api = new CndzkEntranceApi(_extends({
        urlBase: this.config.urlBase
      }, this.config));
    } else if (this.config.apiModel === 'mtop') {
      if (!this.config.businessId) {
        console.error('CnAddress Error: businessId is required');
        return;
      }
      this.api = new CndzkEntranceApi(_extends({}, this.config));
    }
  }
  var _proto = Services.prototype;
  _proto.getTopLevelInfo = /*#__PURE__*/function () {
    var _getTopLevelInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
      var res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return this.api.get('topLevelInfo', _extends({}, params));
          case 2:
            res = _context.sent;
            return _context.abrupt("return", formatJsonpDataForMtop([res], this.config.isJsonpForMtop)[0]);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function getTopLevelInfo(_x) {
      return _getTopLevelInfo.apply(this, arguments);
    }
    return getTopLevelInfo;
  }();
  _proto.getTopLevelList = /*#__PURE__*/function () {
    var _getTopLevelList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
      var res, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return this.api.get('topLevelList', _extends({}, params));
          case 2:
            res = _context2.sent;
            data = [];
            if (!Array.isArray(res)) res = [];
            res.map(function (i) {
              if (i.regions) {
                data = data.concat(i.regions || []);
              } else {
                data.push(i);
              }
            });
            return _context2.abrupt("return", data);
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function getTopLevelList(_x2) {
      return _getTopLevelList.apply(this, arguments);
    }
    return getTopLevelList;
  }();
  _proto.getRegionChain = /*#__PURE__*/function () {
    var _getRegionChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
      var res;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return this.api.get('regionChain', _extends({}, params));
          case 2:
            res = _context3.sent;
            return _context3.abrupt("return", formatJsonpDataForMtop(res, this.config.isJsonpForMtop));
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function getRegionChain(_x3) {
      return _getRegionChain.apply(this, arguments);
    }
    return getRegionChain;
  }();
  _proto.getChildren = /*#__PURE__*/function () {
    var _getChildren = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
      var res, data;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return this.api.get('children', _extends({}, params));
          case 2:
            res = _context4.sent;
            data = (res === null || res === void 0 ? void 0 : res.divisions) || Array.isArray(res) && res || [];
            return _context4.abrupt("return", formatJsonpDataForMtop(data, this.config.isJsonpForMtop));
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function getChildren(_x4) {
      return _getChildren.apply(this, arguments);
    }
    return getChildren;
  }();
  _proto.getRegionChainByName = /*#__PURE__*/function () {
    var _getRegionChainByName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
      var _this = this;
      var res;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return this.api.get('regionChainByName', _extends({}, params));
          case 2:
            res = _context5.sent;
            return _context5.abrupt("return", res.map(function (item) {
              return formatJsonpDataForMtop(item, _this.config.isJsonpForMtop);
            }));
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this);
    }));
    function getRegionChainByName(_x5) {
      return _getRegionChainByName.apply(this, arguments);
    }
    return getRegionChainByName;
  }();
  _proto.getRegionChainByParse = /*#__PURE__*/function () {
    var _getRegionChainByParse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(params) {
      var res;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return this.api.get('regionChainByParse', _extends({}, params, {
              countryCode: 'CN' // 目前只支持中国
            }));
          case 2:
            res = _context6.sent;
            return _context6.abrupt("return", formatJsonpDataForMtop(res, this.config.isJsonpForMtop));
          case 4:
          case "end":
            return _context6.stop();
        }
      }, _callee6, this);
    }));
    function getRegionChainByParse(_x6) {
      return _getRegionChainByParse.apply(this, arguments);
    }
    return getRegionChainByParse;
  }();
  return Services;
}();
export { Services as default };
export function getFullDataByCdn(_x7) {
  return _getFullDataByCdn.apply(this, arguments);
}
function _getFullDataByCdn() {
  _getFullDataByCdn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(cdnUrl) {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          if (!(window.__cn_address_CDNDATA && window.__cn_address_CDNDATA[cdnUrl])) {
            _context7.next = 2;
            break;
          }
          return _context7.abrupt("return", window.__cn_address_CDNDATA[cdnUrl]);
        case 2:
          return _context7.abrupt("return", new Promise(function (resolve) {
            var dataSDK = document.createElement('script');
            dataSDK.src = cdnUrl;
            dataSDK.onload = function () {
              var _window$__cn_address_;
              window.__cn_address_CDNDATA = (_window$__cn_address_ = {}, _window$__cn_address_[cdnUrl] = window.tdist.data, _window$__cn_address_);
              if (window.tdist) {
                window.tdist = null;
              }
              resolve(window.__cn_address_CDNDATA[cdnUrl]);
            };
            document.body.appendChild(dataSDK);
          }));
        case 3:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _getFullDataByCdn.apply(this, arguments);
}